import { createApp } from 'vue'
import App from './App.vue'
import router from './config/router'
import store from "./store";

import 'bootstrap/dist/css/bootstrap.css'

import Maska from 'maska'

import VueNotificationList from '@dafcoe/vue-notification'
import '@dafcoe/vue-notification/dist/vue-notification.css'

import plugins from './config/plugins.js';


import { Field, Form, ErrorMessage, defineRule } from 'vee-validate';

import { configure } from 'vee-validate';

import * as rules from '@vee-validate/rules';
Object.keys(rules).forEach(rule => {
    if (typeof rules[rule] === 'function') {
        defineRule(rule, rules[rule]);
    }
});

configure({
    generateMessage: (context) => {
        const messages = {
            required: `${context.field} é obrigatório.`,
            min_value: `${context.field} deve ter um valor mínimo de ${context.rule.params[0]}.`,
            max_value: `O campo ${context.field} deve ter um valor máximo de ${context.rule.params[0]}.`,
            min_length: `O campo ${context.field} deve ter pelo menos ${context.rule.params[0]} caracteres.`,
            max_length: `O campo ${context.field} deve ter no máximo ${context.rule.params[0]} caracteres.`,
            alpha: `O campo ${context.field} deve conter apenas caracteres alfabéticos.`,
            alpha_num: `O campo ${context.field} deve conter apenas caracteres alfanuméricos.`,
            numeric: `O campo ${context.field} deve conter apenas valores numéricos.`,
            integer: `O campo ${context.field} deve conter apenas valores inteiros.`,
            decimal: `O campo ${context.field} deve ser um número decimal válido.`,
            email: `O campo ${context.field} deve ser um endereço de e-mail válido.`,
            ip: `O campo ${context.field} deve ser um endereço IP válido.`,
            url: `O campo ${context.field} deve ser uma URL válida.`,
            date: `O campo ${context.field} deve ser uma data válida.`,
            date_format: `O campo ${context.field} deve estar no formato ${context.rule.params[0]}.`,
            alpha_spaces: `O campo ${context.field} deve conter apenas caracteres alfabéticos e espaços.`,
            confirmed: `O campo ${context.field} não coincide com o campo de confirmação.`,
            not_in: `O campo ${context.field} contém um valor inválido.`,
            regex: `O campo ${context.field} é inválido.`,
            digits: `O campo ${context.field} deve conter exatamente ${context.rule.params[0]} dígitos.`,
            dimensions: `O campo ${context.field} deve ter as dimensões ${context.rule.params[0]} x ${context.rule.params[1]}.`,
            ext: `O campo ${context.field} deve ter uma extensão válida.`,
            image: `O campo ${context.field} deve ser uma imagem válida.`,
            size: `O campo ${context.field} deve ter um tamanho máximo de ${context.rule.params[0]} KB.`,
            mimes: `O campo ${context.field} deve ter um tipo de arquivo válido.`,
            required_if: `O campo ${context.field} é obrigatório quando ${context.rule.params[0]} é ${context.rule.params[1]}.`,
            required_unless: `O campo ${context.field} é obrigatório a menos que ${context.rule.params[0]} esteja presente.`,
            required_with: `O campo ${context.field} é obrigatório quando ${context.rule.params[0]} está presente.`,
            required_with_all: `O campo ${context.field} é obrigatório quando todos os campos ${context.rule.params.join(', ')} estão presentes.`,
            required_without: `O campo ${context.field} é obrigatório quando ${context.rule.params[0]} não está presente.`,
            required_without_all: `O campo ${context.field} é obrigatório quando nenhum dos campos ${context.rule.params.join(', ')} está presente.`,
            same: `O campo ${context.field} deve ser igual ao campo ${context.rule.params[0]}.`,
            different: `O campo ${context.field} deve ser diferente do campo ${context.rule.params[0]}.`,
            before: `O campo ${context.field} deve ser uma data anterior a ${context.rule.params[0]}.`,
            after: `O campo ${context.field} deve ser uma data posterior a ${context.rule.params[0]}.`,
            between: `O campo ${context.field} deve estar entre ${context.rule.params[0]} e ${context.rule.params[1]}.`,
            digits_between: `O campo ${context.field} deve ter entre ${context.rule.params[0]} e ${context.rule.params[1]} dígitos.`,
            in: `O campo ${context.field} deve estar em ${context.rule.params.join(', ')}.`,
            excluded: `O campo ${context.field} está excluído.`,
            included: `O campo ${context.field} está incluído.`,
            gt: `O campo ${context.field} deve ser maior que ${context.rule.params[0]}.`,
            gte: `O campo ${context.field} deve ser maior ou igual a ${context.rule.params[0]}.`,
            lt: `O campo ${context.field} deve ser menor que ${context.rule.params[0]}.`,
            lte: `O campo ${context.field} deve ser menor ou igual a ${context.rule.params[0]}.`,
            length: `O campo ${context.field} deve ter um comprimento de ${context.rule.params[0]}.`,
            starts_with: `O campo ${context.field} deve começar com um dos seguintes valores: ${context.rule.params.join(', ')}.`,
            ends_with: `O campo ${context.field} deve terminar com um dos seguintes valores: ${context.rule.params.join(', ')}.`,
            before_date: `O campo ${context.field} deve ser uma data anterior a ${context.rule.params[0]}.`,
            after_date: `O campo ${context.field} deve ser uma data posterior a ${context.rule.params[0]}.`,
        };
        const message = messages[context.rule.name] || `O campo ${context.field} é inválido.`;
        return message;
    },
});

const app = createApp(App);

app.component('Field', Field);
app.component('Form', Form);
app.component('ErrorMessage', ErrorMessage);

app.use(Maska)
    .use(VueNotificationList)
    .use(plugins)
    .use(router)
    .use(store)
    .mount('#app');